export var MixinProviders = {
  data: () => ({
    ProvidersLoaded: false,
    ProvidersList: []
  }),
  methods: {
    ProvidersLoad() {
      if (!this.ProvidersLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("tiers/?fk_Type=2", { headers: { Authorization: T_Token } })
          .then(O_Response => {
            this.ProvidersList = [];
            if (O_Response.data != "") {
              this.ProvidersList = O_Response.data;
            }
            this.ProvidersLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    ProvidersReLoad() {
      this.ProvidersLoaded = false;
      this.ProvidersLoad();
    },
    ProvidersGet() {
      this.ProvidersLoad();
      return this.ProvidersList;
    },
    ProvidersGetFKID(T_Provider) {
      // Récupérer le code FK à partir du code Fournisseur (Nom_Rech)
      var T_FKProvider = "";
      var L_Index;
      for (L_Index = 0; L_Index < this.ProvidersList.length; L_Index++) {
        var O_Provider = this.ProvidersList[L_Index];
        if (O_Provider.equisis_code == T_Provider) {
          // Correspond au code fournisseur voulu
          T_FKProvider = O_Provider.id;
          L_Index = this.ProvidersList.length; // On arrête la boucle
        }
      }

      return T_FKProvider;
    }
  }
};
